module.exports = __webpack_public_path__ + "img/hiring-default.eb825040.jpg";